'use strict';

import ngResource from 'angular-resource';

class SaGroupService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/sa_group/:id',
            { id: '@id' },
            {
                index : { method: 'GET',  isArray: true  },
                show  : { method: 'GET',  isArray: false },
                create: { method: 'POST', isArray: false },
                update: { method: 'PUT',  isArray: false },
                destroy: { method: 'DELETE', isArray: false },
            }
        );
    }
}

export default angular.module('leptonApp.SaGroupService', ['ngResource'])
    .service('SaGroupService', ['$resource', SaGroupService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/sa_group/sa_group.service.js